
import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
import CardContainer from "@/components/card/CardContainerNew.vue";
import DefaultProjectImage from "@/components/card/DefaultProjectImageNew.vue";
import CardTitleContainer from "@/components/card/CardTitleContainerNew.vue";
import RouteParams from "@/entities/RouteParams";
import { Project, User } from "@/generated/graphql";
import RouteNames from "@/entities/RouteNames";
import CardSection from "@/components/card/CardSection.vue";
import CardItemBaseContainer from "@/components/card/CardItemBaseContainer.vue";
import getFullNameOrPlaceholder from "@/helpers/getFullNameOrPlaceholder";
import ItemChipsData from "@/entities/ItemChipsData";
import BudgetRange from "@/components/common/BudgetRange.vue";
import { getCardDateFormat } from "@/helpers/date";
import ShortenedText from "@/components/common/ShortenedText.vue";
import CreateGroupConversation from "@/components/inbox/CreateGroupConversation.vue";
import ProjectActivityAction from "@/components/projects/activities/ProjectActivityAction.vue";
import CardSingleChip from "@/components/card/CardSingleChip.vue";
import ProjectAction from "@/components/projects/ProjectAction.vue";
import ConversationUserDataForModal from "@/entities/ConversationUserDataForModal";
import Roles from "@/entities/Roles";
import getProjectActivitiesCount from "@/helpers/project/getProjectActivitiesCount";
import CardItemTitle from "@/components/card/CardItemTitle.vue";
import ProjectStatus from "@/components/projects/ProjectStatus.vue";
import isHoursUnconfirmed from "@/helpers/project/isHoursUnconfirmed";
import ContainerSize from "@/components/uiSize/ContainerSize.vue";

@Component({
  components: {
    ContainerSize,
    ProjectStatus,
    CardItemTitle,
    ProjectAction,
    CardSingleChip,
    ProjectActivityAction,
    CreateGroupConversation,
    ShortenedText,
    BudgetRange,
    CardItemBaseContainer,
    CardSection,
    CardTitleContainer,
    DefaultProjectImage,
    CardContainer,
  },
})
export default class ProjectCard extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly project!: Project;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Boolean, default: false }) readonly hideManager!: boolean;
  @PropSync("descriptionBlockHeight", { type: Number, default: undefined })
  descriptionBlockHeightValue?: number;

  RouteNames = RouteNames;
  get hasUnconfirmedHours(): boolean {
    return isHoursUnconfirmed(this.project.project_activities);
  }

  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }

  get manager(): ItemChipsData | undefined {
    const manager = this.project.manager;

    if (!manager) {
      return;
    }

    const { id, given_name, family_name, avatar } = manager.user;

    return {
      id,
      avatar: avatar || undefined,
      name: getFullNameOrPlaceholder(given_name, family_name),
      routeParams: {
        name: RouteNames.MANAGER_ABOUT,
        params: {
          id: manager.id,
        },
      },
    };
  }

  get projectActivitiesPageRoute(): RouteParams<{ id: string }> {
    return {
      name: RouteNames.PROJECT_ACTIVITY,
      params: {
        id: this.project.id,
      },
    };
  }

  get clientId(): string {
   return this.project.client_id;
  }

}
